module.exports = __webpack_public_path__ + "static/quadrone-b55da28f938dc03c07c6bfd98f784ccf.jpg";